
import ProductCard from './ProductCardV2.vue'
import EralpPagination from 'gurhan/vue/BootstrapPagination.vue'
import EmptySearch from '../Search/EmptySearch.vue'
export default {
  components: {
    ProductCard,
    EralpPagination,
    EmptySearch,
    ProductCardVerticalImage: () =>
      import('@/components/Products/ProductCardVerticalImage.vue'),
  },
  props: {
    products: {
      default: () => [],
    },
    count: {
      default: 0,
    },
    startCount: {
      default: 0,
    },
    endCount: {
      default: 0,
    },
    page: {
      default: 0,
    },
    pages: {
      default: 0,
    },
    title: {
      default: '',
    },
    loading: {
      default: false,
    },
  },
  computed: {
    Contents() {
      return this.$store.state.settings.contents
    },
    ProductCardComponent() {
      const productCardComponent = this.Contents.componentSettings.find(
        (c) => c.title === 'ProductCard'
      )
      if (!productCardComponent) return 'ProductCard'
      else return productCardComponent.description
    },
  },
}
